function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.707 7.294v1.414l-6 6-1.414-1.414 4.293-4.293H2v-2h9.586L7.293 2.708l1.414-1.414 6 6z",
  fill: "currentColor"
});

const SvgArrowRight = props => React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _ref);

export default SvgArrowRight;